import PropTypes from "prop-types"

export const SCROLL = "scroll"
export const CLICK = "click"
export const HEADER = "header"
export const TERMS = "terms"
export const COUNTRY = "country"
export const ES = "es"
export const QS = "qs"
export const SMOOTH = "smooth"
export const WHOLE_BANNER_CLICKABLE = "whole banner clickable"
export const GREEN_CTA = "green CTA"
export const CENTERED_TEXT = "centered text"
export const DARK_OVERLAY = "dark overlay"
export const BLACK_TEXT = "black text"
export const OVERLAPPING_PAYMENTS = "overlapping payments"
export const OVERLAPPING_GAMES = "overlapping games"
export const ARROW_ANIMATION = "arrow animation"
export const PULSATING_CTA = "pulsating CTA"
export const ARROW_IN_CTA = "arrow in CTA"
export const COMPACT_THREE_STEPS = "compact three steps"
export const MINI_THREE_STEPS = "mini three steps"
export const PLAIN_BANNER = "plain banner"
export const HIDE_GAMES_CONTENT_SECTION = "hide games content section"
export const HIDE_SUPPORT_SECTION = "hide support section"
export const HIDE_AWARDS_SECTION = "hide awards section"
export const HIDE_DOWNLOAD_APP_SECTION = "hide download app section"

export const URL = {
  login: "https://www.leovegas.com/login",
  signup: "https://www.leovegas.com/signup"
}

export const GATSBY_IMAGE_FIXED_PROPTYPE = PropTypes.shape({
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  src: PropTypes.string.isRequired,
  srcSet: PropTypes.string.isRequired,
  base64: PropTypes.string,
  tracedSVG: PropTypes.string,
  srcWebp: PropTypes.string,
  srcSetWebp: PropTypes.string,
  media: PropTypes.string
})

export const GATSBY_IMAGE_FLUID_PROPTYPE = PropTypes.shape({
  aspectRatio: PropTypes.number.isRequired,
  src: PropTypes.string.isRequired,
  srcSet: PropTypes.string.isRequired,
  sizes: PropTypes.string.isRequired,
  base64: PropTypes.string,
  tracedSVG: PropTypes.string,
  srcWebp: PropTypes.string,
  srcSetWebp: PropTypes.string,
  media: PropTypes.string,
  maxWidth: PropTypes.number,
  maxHeight: PropTypes.number
})

const IMAGE_SOURCE = PropTypes.shape({
  sizes: PropTypes.string,
  srcSet: PropTypes.string,
  type: PropTypes.string
})

export const GATSBY_IMAGE = PropTypes.shape({
  gatsbyImageData: PropTypes.shape({
    height: PropTypes.number,
    images: PropTypes.shape({
      fallback: PropTypes.shape({
        sizes: PropTypes.string,
        src: PropTypes.string,
        srcSet: PropTypes.string
      }),
      sources: PropTypes.arrayOf(IMAGE_SOURCE)
    }),
    layout: PropTypes.string,
    placeholder: PropTypes.shape({
      fallback: PropTypes.string
    }),
    width: PropTypes.number
  })
})

export const COOKIE = {
  isCookiePolicyAccepted: "isCookiePolicyAccepted"
}

export const CURRENCY = {
  AED: "د.إ",
  AFN: "؋",
  ALL: "L",
  AMD: "֏",
  ANG: "ƒ",
  AOA: "Kz",
  ARS: "$",
  AUD: "$",
  AWG: "ƒ",
  AZN: "₼",
  BAM: "KM",
  BBD: "$",
  BDT: "৳",
  BGN: "лв",
  BHD: ".د.ب",
  BIF: "FBu",
  BMD: "$",
  BND: "$",
  BOB: "$b",
  BRL: "R$",
  BSD: "$",
  BTC: "฿",
  BTN: "Nu.",
  BWP: "P",
  BYR: "Br",
  BYN: "Br",
  BZD: "BZ$",
  CAD: "$",
  CDF: "FC",
  CHF: "CHF",
  CLP: "$",
  CNY: "¥",
  COP: "$",
  CRC: "₡",
  CUC: "$",
  CUP: "₱",
  CVE: "$",
  CZK: "Kč",
  DJF: "Fdj",
  DKK: "kr",
  DOP: "RD$",
  DZD: "دج",
  EEK: "kr",
  EGP: "£",
  ERN: "Nfk",
  ETB: "Br",
  ETH: "Ξ",
  EUR: "€",
  FJD: "$",
  FKP: "£",
  GBP: "£",
  GEL: "₾",
  GGP: "£",
  GHC: "₵",
  GHS: "GH₵",
  GIP: "£",
  GMD: "D",
  GNF: "FG",
  GTQ: "Q",
  GYD: "$",
  HKD: "$",
  HNL: "L",
  HRK: "kn",
  HTG: "G",
  HUF: "Ft",
  IDR: "Rp",
  ILS: "₪",
  IMP: "£",
  INR: "₹",
  IQD: "ع.د",
  IRR: "﷼",
  ISK: "kr",
  JEP: "£",
  JMD: "J$",
  JOD: "JD",
  JPY: "¥",
  KES: "KSh",
  KGS: "лв",
  KHR: "៛",
  KMF: "CF",
  KPW: "₩",
  KRW: "₩",
  KWD: "KD",
  KYD: "$",
  KZT: "лв",
  LAK: "₭",
  LBP: "£",
  LKR: "₨",
  LRD: "$",
  LSL: "M",
  LTC: "Ł",
  LTL: "Lt",
  LVL: "Ls",
  LYD: "LD",
  MAD: "MAD",
  MDL: "lei",
  MGA: "Ar",
  MKD: "ден",
  MMK: "K",
  MNT: "₮",
  MOP: "MOP$",
  MRO: "UM",
  MRU: "UM",
  MUR: "₨",
  MVR: "Rf",
  MWK: "MK",
  MXN: "$",
  MYR: "RM",
  MZN: "MT",
  NAD: "$",
  NGN: "₦",
  NIO: "C$",
  NOK: "kr",
  NPR: "₨",
  NZD: "$",
  OMR: "﷼",
  PAB: "B/.",
  PEN: "S/.",
  PGK: "K",
  PHP: "₱",
  PKR: "₨",
  PLN: "zł",
  PYG: "Gs",
  QAR: "﷼",
  RMB: "￥",
  RON: "lei",
  RSD: "Дин.",
  RUB: "₽",
  RWF: "R₣",
  SAR: "﷼",
  SBD: "$",
  SCR: "₨",
  SDG: "ج.س.",
  SEK: "kr",
  SGD: "$",
  SHP: "£",
  SLL: "Le",
  SOS: "S",
  SRD: "$",
  SSP: "£",
  STD: "Db",
  STN: "Db",
  SVC: "$",
  SYP: "£",
  SZL: "E",
  THB: "฿",
  TJS: "SM",
  TMT: "T",
  TND: "د.ت",
  TOP: "T$",
  TRL: "₤",
  TRY: "₺",
  TTD: "TT$",
  TVD: "$",
  TWD: "NT$",
  TZS: "TSh",
  UAH: "₴",
  UGX: "USh",
  USD: "$",
  UYU: "$U",
  UZS: "лв",
  VEF: "Bs",
  VND: "₫",
  VUV: "VT",
  WST: "WS$",
  XAF: "FCFA",
  XBT: "Ƀ",
  XCD: "$",
  XOF: "CFA",
  XPF: "₣",
  YER: "﷼",
  ZAR: "R",
  ZWD: "Z$"
}
